import { v4 as uuidv4 } from "uuid";
import { getStoredValue, setStoredValue } from "./storage";

export interface BotReply {
  response: {
    answer?: string;
    audio?: string;
    ask_for_resume?: boolean;
    show_download?: boolean;
    suggested_courses?: Array<{ course_name: string; course_description: string }>;
    answerId?: string;
    getFeedback?: boolean;
  };
}

const proxyPrefix = "/edp/";

export const sendQuery = async (query: string, inputType: string, file?: File | null): Promise<BotReply["response"]> => {
  const formData = new FormData();
  let token = getStoredValue<string>("sessionToken");
  if (!token) {
    token = uuidv4();
    setStoredValue("sessionToken", token);
  }

  if (file) {
    formData.append("file", file);
  }
  formData.append("query", query);
  formData.append("inputType", inputType);
  formData.append("sessionToken", token);
  formData.append("userAgent", navigator.userAgent);
  formData.append("audio", "");

  const response = await fetch(`${proxyPrefix}bot/getResponse`, {
    method: "POST",
    body: formData
  });
  if (!response.ok) {
    throw new Error("Failed to get bot response");
  }
  const data = await response.json();
  return {
    answer: data.answer,
    audio: data.audioURL || data.audio,
    ask_for_resume: data.ask_for_resume,
    show_download: data.show_download,
    suggested_courses: data.suggested_courses,
    answerId: data.answer_id || data.answerId,
    getFeedback: data.getFeedback,
  };
};


export const sendFeedback = async (id: string, text: string, val: "true" | "false"): Promise<void> => {
  const formData = new FormData();
  let token = getStoredValue<string>("sessionToken");
  if (!token) {
    token = uuidv4();
    setStoredValue("sessionToken", token);
  }

  formData.append("answer_id", id);
  formData.append("reaction", val === "true" ? "like" : "dislike");
  formData.append("sessionToken", token);
  formData.append("userAgent", navigator.userAgent);
  formData.append("comment", text);

  const response = await fetch(`${proxyPrefix}bot/feedback`, {
    method: "POST",
    body: formData
  });
  if (!response.ok) {
    throw new Error("Failed to send feedback");
  }
};

export const getBotDashboard = async (from?: string, to?: string, indentType: string = "faq"): Promise<any> => {
  const formData = new FormData();

  // Default 'from' and 'to' to yesterday and today if not provided
  let finalFrom = from;
  let finalTo = to;
  if (!finalFrom || !finalTo) {
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const formatDate = (date: Date) => {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    };

    if (!finalFrom) finalFrom = formatDate(yesterday);
    if (!finalTo) finalTo = formatDate(today);
  }

  formData.append("from", finalFrom);
  formData.append("to", finalTo);

  const url = `${proxyPrefix}bot/dashboard?indentType=${encodeURIComponent(indentType)}`;
  const response = await fetch(url, {
    method: "POST",
    body: formData
  });
  if (!response.ok) {
    throw new Error("Failed to get bot dashboard data");
  }
  return response.json();
};

